// Chatbox.js
import axios from "axios";
import React, { useEffect, useState } from "react";
import { AuthContext } from "../context/AuthContext";
import {useContext} from 'react';
import ChatEntry from './ChatEntry';


const ChatBox = ({ handleNavigate }) => {
    const [message, setMessage] = useState('');
  
    const sendMessage = () => {
      // Here you can integrate with sending message logic or navigation if needed
      console.log("Message to send:", message);
      // Reset the input after sending
      setMessage('');
      // If you need to navigate on send, call handleNavigate here
      // handleNavigate(userid); // Uncomment and pass userid if necessary
    };
  
    return (
      <div style={{ width: '100%', maxWidth: '880px', backgroundColor: '#f0f0f0', border: '1px solid #ccc', padding: '10px', boxSizing: 'border-box' }}>
        <div style={{ width: '100%', height: '500px', backgroundColor: 'white', border: '1px solid #ccc', marginBottom: '10px', overflowY: 'auto' }}>
          {/* Chat messages would go here */}
        </div>
        <input
          type="text"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          style={{ width: 'calc(100% - 90px)', padding: '10px', marginRight: '10px', boxSizing: 'border-box', float: 'left' }}
          placeholder="Type your message here..."
        />
        <button
          onClick={sendMessage}
          style={{ width: '80px', padding: '10px 20px', backgroundColor: '#007BFF', color: 'white', textAlign: 'center', border: 'none', cursor: 'pointer' }}
        >
          Send
        </button>
        <div style={{ clear: 'both' }}></div>
      </div>
    );
  }
  
  export default ChatBox;